import { Injectable } from '@angular/core';
import { SharedService } from './shared.service';
import { EventTypes } from '../event-types';

@Injectable({
  providedIn: 'root'
})
export class ReportBannerService {
  // Flag to track if we're in bulk upload mode
  private isBulkUploadMode = false;
  private bannerTimeoutId: any = null;

  constructor(private sharedService: SharedService) {}

  /**
   * Set bulk upload mode - when true, individual report banners will be suppressed
   */
  setBulkUploadMode(isActive: boolean): void {
    this.isBulkUploadMode = isActive;

    // If activating bulk mode, show the bulk reports banner
    if (isActive) {
      this.showBulkReportsGeneratingBanner();

      // Auto-close the banner after 5 seconds
      this.bannerTimeoutId = setTimeout(() => {
        // Just close the banner but keep bulk mode active to suppress individual banners
        this.sharedService.emitEvent(EventTypes.CLOSE_REPORT_BANNER, {});
      }, 5000);
    } else {
      // When deactivating, close any open banners
      this.sharedService.emitEvent(EventTypes.CLOSE_REPORT_BANNER, {});

      // Clear any existing timeout
      if (this.bannerTimeoutId) {
        clearTimeout(this.bannerTimeoutId);
        this.bannerTimeoutId = null;
      }
    }
  }

  /**
   * Checks if currently in bulk upload mode
   */
  isInBulkUploadMode(): boolean {
    return this.isBulkUploadMode;
  }

  /**
   * Forcefully disable bulk upload mode without emitting any banner close events
   * Used when starting a new individual search to ensure banner events aren't blocked
   */
  forceDisableBulkUploadMode(): void {
    this.isBulkUploadMode = false;

    // Clear any existing timeout
    if (this.bannerTimeoutId) {
      clearTimeout(this.bannerTimeoutId);
      this.bannerTimeoutId = null;
    }
  }

  /**
   * Shows a single banner for bulk report generation
   */
  private showBulkReportsGeneratingBanner(): void {
    this.sharedService.emitEvent(EventTypes.SHOW_LOADING_REPORT_BANNER, {
      isBulkUpload: true,
      message: 'Reports are generating. Please wait...'
    });
  }
}
